import api from './api';

// Biblioteca personal de imagenes. La API resuelve el dueño desde el token, asi
// que aqui nunca se manda un id de usuario: no hay forma de pedir la biblioteca
// de otro ni por error.

// Mismos topes que impone el servidor. Se repiten aqui solo para avisar antes
// de gastar la subida; el que manda es el de la API, que es el que no se puede
// esquivar desde el navegador.
export const MAX_RESOURCES = 50;

export const MAX_FILE_SIZE_MB = 3;

export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

// Carpetas y recursos en una sola llamada, con la cuota ya calculada.
export const fetchLibrary = async () => {
	const response = await api.get('user_resources/library');

	return response.data;
};

export const createFolder = async (name) => {
	const response = await api.post('user_resources/folders', {name});

	return response.data;
};

export const renameFolder = async (folder_id, name) => {
	const response = await api.put(`user_resources/folders/${folder_id}`, {name});

	return response.data;
};

export const deleteFolder = async (folder_id) => {
	const response = await api.delete(`user_resources/folders/${folder_id}`);

	return response.data;
};

// Una imagen por llamada: asi una que falle no se lleva por delante a las demas
// de la misma tanda, y la cuota se comprueba contra el total real en cada una.
export const uploadResource = async (file, folder_id) => {
	const form = new FormData();
	form.append('file', file);

	const query = folder_id ? `?folder_id=${folder_id}` : '';
	const response = await api.post(`user_resources/upload${query}`, form);

	return response.data;
};

export const moveResource = async (id, folder_id) => {
	const response = await api.put(`user_resources/${id}/move`, {folder_id: folder_id || null});

	return response.data;
};

export const deleteResource = async (id) => {
	const response = await api.delete(`user_resources/${id}`);

	return response.data;
};

// El mensaje util casi siempre viene del servidor: "has llegado al limite"
// dice bastante mas que "Request failed with status code 409".
export const resourceErrorText = (error) => {
	const data = error.response && error.response.data;
	const message = (data && (data.error?.message || data.message)) || '';

	if (message) {
		return message;
	}

	if (error.response) {
		return `The server answered HTTP ${error.response.status}`;
	}

	return error.message || 'No response from the server';
};
